import React from "react";
import Layout from "../components/Layout/Layout";

function Policy() {
  return (
    <Layout title="Policy -ecomm">
      <div class="container">
        <h2 class="text-center m-3" style={{color:"#a10a1b"}}>Privacy Policy</h2>
        <div class="row d-flex">
          <div class="col-md-4">
            <img
              src="https://images.unsplash.com/photo-1613987750911-f768497fb94b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="privacy"
              class="img-fluid"
            />
          </div>
          <div class="col-md-8">
            <div>
              <p>
                At XYZ E-commerce, we are committed to protecting your privacy.
                This Privacy Policy explains how we collect, use, disclose, and
                safeguard your information when you visit our website
                (https://www.xyzecommerce.com),  
              </p>
              <h4>Information We Collect</h4>
              <p>
                We collect personal information that you voluntarily provide to
                us when registering on the Site, expressing an interest in
                
              </p>
              <h4>How We Use Your Information</h4>
              <p>
                We may use the information we collect about you for various
                purposes, including to: - Provide, maintain, and improve our
                
              </p>
              <h4>Information Sharing and Disclosure</h4>
              <p>
                We may share your information with third parties who provide
                services on our  
              </p>
        
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Policy;
